// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { AssetInfoFragmentDoc } from '../../../assets/AssetPreview.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PhotosTileQueryVariables = Types.Exact<{
  filter: Types.JobLogImageFilter;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type PhotosTileQuery = { __typename?: 'Query', jobLogImages: Array<{ __typename?: 'JobLogImage', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } }> };


export const PhotosTileDocument = gql`
    query PhotosTile($filter: JobLogImageFilter!, $limit: Int) {
  jobLogImages(filter: $filter, limit: $limit) {
    id
    asset {
      ...AssetInfo
    }
  }
}
    ${AssetInfoFragmentDoc}`;

/**
 * __usePhotosTileQuery__
 *
 * To run a query within a React component, call `usePhotosTileQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhotosTileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhotosTileQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePhotosTileQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PhotosTileQuery, PhotosTileQueryVariables> & ({ variables: PhotosTileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PhotosTileQuery, PhotosTileQueryVariables>(PhotosTileDocument, options);
      }
export function usePhotosTileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PhotosTileQuery, PhotosTileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PhotosTileQuery, PhotosTileQueryVariables>(PhotosTileDocument, options);
        }
export function usePhotosTileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PhotosTileQuery, PhotosTileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PhotosTileQuery, PhotosTileQueryVariables>(PhotosTileDocument, options);
        }
export type PhotosTileQueryHookResult = ReturnType<typeof usePhotosTileQuery>;
export type PhotosTileLazyQueryHookResult = ReturnType<typeof usePhotosTileLazyQuery>;
export type PhotosTileSuspenseQueryHookResult = ReturnType<typeof usePhotosTileSuspenseQuery>;
export type PhotosTileQueryResult = Apollo.QueryResult<PhotosTileQuery, PhotosTileQueryVariables>;